import Component from './ColumnChooserTable.component';

export default Component;
